/**
 * CLC-TSE-ATF-01 — Super Elixir above-the-fold buybox
 */

const FLAVOR_ORDER = ['pl', 'mb', 'bo', 'lg', 'un', 'mp'];

const INGREDIENTS = {
  pl: [
    { label: 'Greens', text: 'Barley grass, wheatgrass, spirulina, spinach, broccoli, kelp' },
    { label: 'Gut', text: 'Prebiotics, live probiotics, aloe vera, psyllium husk' },
    { label: 'Skin & hair', text: 'Biotin, zinc, copper, magnesium' },
    { label: 'Mind & body', text: 'Ginseng, green tea extract, turmeric, maitake & shiitake' },
  ],
  mb: [
    { label: 'Greens', text: 'Barley grass, wheatgrass, spirulina, spinach, broccoli, kelp' },
    { label: 'Gut', text: 'Prebiotics, live probiotics, aloe vera, psyllium husk' },
    { label: 'Skin & hair', text: 'Biotin, zinc, copper, magnesium' },
    { label: 'Mind & body', text: 'Ginseng, green tea extract, turmeric, maitake & shiitake' },
  ],
  bo: [
    { label: 'Greens', text: 'Barley grass, wheatgrass, spirulina, spinach, broccoli, kelp' },
    { label: 'Gut', text: 'Prebiotics, live probiotics, aloe vera, psyllium husk' },
    { label: 'Skin & hair', text: 'Biotin, zinc, copper, magnesium' },
    { label: 'Mind & body', text: 'Ginseng, green tea extract, turmeric, maitake & shiitake' },
  ],
  lg: [
    { label: 'Greens', text: 'Barley grass, wheatgrass, spirulina, spinach, broccoli, kelp' },
    { label: 'Gut', text: 'Prebiotics, live probiotics, aloe vera, psyllium husk' },
    { label: 'Skin & hair', text: 'Biotin, zinc, copper, magnesium' },
    { label: 'Mind & body', text: 'Ginseng, green tea extract, turmeric, maitake & shiitake' },
  ],
  un: [
    { label: 'Greens', text: 'Barley grass, wheatgrass, spirulina, spinach, broccoli, kelp' },
    { label: 'Gut', text: 'Prebiotics, live probiotics, aloe vera, psyllium husk' },
    { label: 'Skin & hair', text: 'Biotin, zinc, copper, magnesium' },
    { label: 'Mind & body', text: 'Ginseng, green tea extract, turmeric, maitake & shiitake' },
  ],
  mp: [
    { label: 'Greens', text: 'Barley grass, wheatgrass, spirulina, spinach, broccoli, kelp' },
    { label: 'Gut', text: 'Prebiotics, live probiotics, aloe vera, psyllium husk' },
    { label: 'Skin & hair', text: 'Biotin, zinc, copper, magnesium' },
    { label: 'Mind & body', text: 'Ginseng, green tea extract, turmeric, maitake & shiitake' },
  ],
};

const NUTRI = {
  pl: {
    ing: 'Barley Grass (Hordeum vulgare) Powder, Wheatgrass (Triticum aestivum) Powder, Pineapple (Ananas comusus) Fruit Powder, Apple (Malus pumila) Fruit Powder, Chicory Root Fibre (Fructooligosaccharides), Alfalfa (Medicago sativa) Leaf Powder, Spinach (Spinacia oleracea) Leaf Powder, Goji Berry (Lycium barbarum) Fruit Extract (4:1), Psyllium Husk (Plantago ovata) Powder, L-Glutamine, Linseed (Linum usitatissimum) Extract (4:1), Carrot (Daucus carota) Powder, Gum Blend (Guar Gum, Gum Acacia, Xanthan Gum), Natural Flavours, Xylitol, Calcium Citrate, Lemon (Citrus limon) Fruit Powder, Lime (Citrus latifolia) Fruit Powder, Acai Berry (Euterpe oleracea) Fruit Powder, Pomegranate (Punica granatum) Fruit Powder, Spirulina (Spirulina platensis) Powder, Papaya (Carica papaya) Fruit Powder, Beetroot (Beta vulgaris) Powder, Broccoli (Brassica oleracea) Powder, Grape Seed (Vitis vinifera) Extract (4:1), Siberian Ginseng (Eleutherococcus senticosus) Root Extract (4:1), Kelp (Fucus vesiculosus) Whole Plant Extract (4:1), Milk Thistle (Silybum marianum) Extract (4:1), Magnesium Citrate, Zinc Gluconate, Dandelion (Taraxacum officinale) Extract (5:1), Maitake Mushroom (Grifola frondosa) Extract (4:1), Shiitake Mushroom (Lentinula edodes) Extract (4:1), Green Tea (Camellia sinensis) Extract (4:1), Turmeric Root (Curcuma longa) Extract (20:1), Aloe Vera Gel (Aloe barbadensis) Extract (200:1), Live Culture Blend (Lactobacillus acidophilus, Bifidobacterium bifidum, Bifidobacterium lactis, Bifidobacterium longum), Horsetail (Equisetum arvense) Extract (10:1), Biotin, Steviol Glycosides, Carotene Powder, Copper Gluconate, Pectin, Selenomethionine.',
    note: 'Ingredients differ by flavour. This list follows the flavour selected above. *Organic ingredients',
  },
  mb: {
    ing: 'Barley Grass (Hordeum vulgare) Powder, Wheatgrass (Triticum aestivum) Powder, Mixed Berry Fruit Powder Blend, Apple (Malus pumila) Fruit Powder, Chicory Root Fibre (Fructooligosaccharides), Alfalfa (Medicago sativa) Leaf Powder, Spinach (Spinacia oleracea) Leaf Powder, Psyllium Husk (Plantago ovata) Powder, L-Glutamine, Natural Flavours, Xylitol, Calcium Citrate, Spirulina (Spirulina platensis) Powder, Beetroot (Beta vulgaris) Powder, Broccoli (Brassica oleracea) Powder, Siberian Ginseng (Eleutherococcus senticosus) Root Extract (4:1), Kelp (Fucus vesiculosus) Whole Plant Extract (4:1), Magnesium Citrate, Zinc Gluconate, Maitake Mushroom (Grifola frondosa) Extract (4:1), Shiitake Mushroom (Lentinula edodes) Extract (4:1), Green Tea (Camellia sinensis) Extract (4:1), Turmeric Root (Curcuma longa) Extract (20:1), Aloe Vera Gel (Aloe barbadensis) Extract (200:1), Live Culture Blend, Biotin, Steviol Glycosides, Copper Gluconate, Selenomethionine.',
    note: 'Ingredients differ by flavour. This list follows the flavour selected above. *Organic ingredients',
  },
  bo: {
    ing: 'Barley Grass (Hordeum vulgare) Powder, Wheatgrass (Triticum aestivum) Powder, Blood Orange (Citrus sinensis) Fruit Powder, Apple (Malus pumila) Fruit Powder, Chicory Root Fibre (Fructooligosaccharides), Alfalfa (Medicago sativa) Leaf Powder, Spinach (Spinacia oleracea) Leaf Powder, Psyllium Husk (Plantago ovata) Powder, L-Glutamine, Natural Flavours, Xylitol, Calcium Citrate, Spirulina (Spirulina platensis) Powder, Beetroot (Beta vulgaris) Powder, Broccoli (Brassica oleracea) Powder, Siberian Ginseng (Eleutherococcus senticosus) Root Extract (4:1), Kelp (Fucus vesiculosus) Whole Plant Extract (4:1), Magnesium Citrate, Zinc Gluconate, Maitake Mushroom (Grifola frondosa) Extract (4:1), Shiitake Mushroom (Lentinula edodes) Extract (4:1), Green Tea (Camellia sinensis) Extract (4:1), Turmeric Root (Curcuma longa) Extract (20:1), Aloe Vera Gel (Aloe barbadensis) Extract (200:1), Live Culture Blend, Biotin, Steviol Glycosides, Copper Gluconate, Selenomethionine.',
    note: 'Ingredients differ by flavour. This list follows the flavour selected above. *Organic ingredients',
  },
  lg: {
    ing: 'Barley Grass (Hordeum vulgare) Powder, Wheatgrass (Triticum aestivum) Powder, Lemon (Citrus limon) Fruit Powder, Ginger (Zingiber officinale) Root Powder, Apple (Malus pumila) Fruit Powder, Chicory Root Fibre (Fructooligosaccharides), Alfalfa (Medicago sativa) Leaf Powder, Spinach (Spinacia oleracea) Leaf Powder, Psyllium Husk (Plantago ovata) Powder, L-Glutamine, Natural Flavours, Xylitol, Calcium Citrate, Spirulina (Spirulina platensis) Powder, Beetroot (Beta vulgaris) Powder, Broccoli (Brassica oleracea) Powder, Siberian Ginseng (Eleutherococcus senticosus) Root Extract (4:1), Kelp (Fucus vesiculosus) Whole Plant Extract (4:1), Magnesium Citrate, Zinc Gluconate, Maitake Mushroom (Grifola frondosa) Extract (4:1), Shiitake Mushroom (Lentinula edodes) Extract (4:1), Green Tea (Camellia sinensis) Extract (4:1), Turmeric Root (Curcuma longa) Extract (20:1), Aloe Vera Gel (Aloe barbadensis) Extract (200:1), Live Culture Blend, Biotin, Steviol Glycosides, Copper Gluconate, Selenomethionine.',
    note: 'Ingredients differ by flavour. This list follows the flavour selected above. Contains wheat. *Organic ingredients',
  },
  un: {
    ing: 'Barley Grass (Hordeum vulgare) Powder, Wheatgrass (Triticum aestivum) Powder, Apple (Malus pumila) Fruit Powder, Chicory Root Fibre (Fructooligosaccharides), Alfalfa (Medicago sativa) Leaf Powder, Spinach (Spinacia oleracea) Leaf Powder, Psyllium Husk (Plantago ovata) Powder, L-Glutamine, Calcium Citrate, Spirulina (Spirulina platensis) Powder, Beetroot (Beta vulgaris) Powder, Broccoli (Brassica oleracea) Powder, Siberian Ginseng (Eleutherococcus senticosus) Root Extract (4:1), Kelp (Fucus vesiculosus) Whole Plant Extract (4:1), Magnesium Citrate, Zinc Gluconate, Maitake Mushroom (Grifola frondosa) Extract (4:1), Shiitake Mushroom (Lentinula edodes) Extract (4:1), Green Tea (Camellia sinensis) Extract (4:1), Turmeric Root (Curcuma longa) Extract (20:1), Aloe Vera Gel (Aloe barbadensis) Extract (200:1), Live Culture Blend, Biotin, Carotene Powder, Copper Gluconate, Selenomethionine.',
    note: 'Ingredients differ by flavour. This list follows the flavour selected above. Contains wheat. *Organic ingredients',
  },
  mp: {
    ing: 'Mixed Pack includes a selection of Super Elixir flavours. See each flavour’s nutrition panel for its full ingredient list.',
    note: 'Mixed Pack contains more than one flavour. Ingredient lists differ by pouch.',
  },
};

const PLANS = {
  monthly: {
    name: 'The 30-Day Ritual Kit',
    sub: '<b>20% off & free shipping</b> on every order',
    ship: 'Delivered every 30 days',
    el: 'The Super Elixir™ 300g',
    elp: '{F} · a new pouch each month',
    tag: 'Monthly',
    keep: '<b>Yours to keep.</b> Only the Elixir renews monthly.',
    giftIntro: 'A free gift with each of your next three deliveries.',
    cta: 'Start My 30-Day Ritual',
    under: '<b>No lock-in.</b> Pause, skip or cancel anytime, free of charge.',
    recap: '20% off & free shipping & free gifts',
    extra: false,
  },
  p90: {
    name: 'The 90-Day Ritual Kit',
    sub: '<b>30% off & free shipping</b> on every order',
    ship: 'Delivered together, every 90 days',
    el: 'The Super Elixir™ 300g × 3',
    elp: '{F} · three pouches, up front',
    tag: 'Every 90 days',
    keep: '<b>Yours to keep.</b> Only the Elixirs renew every 3 months.',
    giftIntro: 'A free gift with every 90-day delivery.',
    giftDeliveryLabels: ['Delivery 1', 'Delivery 2', 'Delivery 3'],
    cta: 'Start My 90-Day Ritual',
    under: '<b>No lock-in.</b> Pause, skip or cancel anytime, free of charge.',
    recap: '30% off & free shipping & free gifts',
    extra: true,
  },
};

const FUTURE_GIFTS = [
  { month: 'Month 1', title: 'The Skin Elixir', desc: 'Glow from within, daily', was: '$54' },
  { month: 'Month 2', title: 'The Collagen Elixir', desc: 'Skin, hair & nail support', was: '$60' },
  { month: 'Month 3', title: 'The Super Elixir™ New Flavor', desc: 'A full second jar, on us', was: '$89' },
];

class ClcTseAtf01 extends HTMLElement {
  /** @type {ReturnType<typeof JSON.parse>} */
  #config;

  /** @type {'monthly' | 'p90'} */
  #plan = 'monthly';

  /** @type {string} */
  #flavor = 'pl';

  /** @type {number} */
  #galleryIndex = 0;

  /** @type {((e: PageTransitionEvent) => void) | null} */
  #onPageShow = null;

  connectedCallback() {
    const configEl = this.querySelector('[data-atf-config]');
    if (!(configEl instanceof HTMLScriptElement)) return;

    this.#config = JSON.parse(configEl.textContent || '{}');
    this.#plan = this.dataset.defaultPlan === 'p90' ? 'p90' : 'monthly';
    this.#flavor = this.dataset.defaultFlavor || 'pl';

    this.#buildFlavorButtons();
    this.#bindEvents();
    this.#render();
    this.#initSticky();
    this.#resetCheckoutUi();

    // Back-forward cache keeps "Starting checkout…" — reset when user returns from checkout
    this.#onPageShow = () => this.#resetCheckoutUi();
    window.addEventListener('pageshow', this.#onPageShow);
  }

  disconnectedCallback() {
    if (this.#onPageShow) {
      window.removeEventListener('pageshow', this.#onPageShow);
      this.#onPageShow = null;
    }
  }

  #money(cents) {
    const amount = (cents / 100).toFixed(2);
    const fmt = this.#config.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }

  #dailyPrice(cents, days) {
    return this.#money(Math.round(cents / days));
  }

  #getVariant() {
    return this.#config.plans[this.#plan]?.variants?.[this.#flavor];
  }

  /** @param {string | null | undefined} url */
  #isUsableImage(url) {
    return typeof url === 'string' && url.length > 0 && url !== 'null';
  }

  /** @returns {string | null} */
  #getPlanHeroImage() {
    // Customizer heroes first (theme editor uploads), then Shopify variant art
    const heroPlan = this.#config.images?.hero?.[this.#plan]?.[this.#flavor];
    if (this.#isUsableImage(heroPlan)) return heroPlan;

    if (this.#plan === 'p90') {
      const from90 = this.#config.variantImages90?.[this.#flavor];
      if (this.#isUsableImage(from90)) return from90;

      const featured = this.#getVariant()?.featuredImage;
      if (this.#isUsableImage(featured)) return featured;
    }

    return null;
  }

  /** @returns {string[]} */
  #buildGalleryImages() {
    const mediaByFlavor =
      this.#plan === 'p90' ? this.#config.mediaByFlavor90 : this.#config.mediaByFlavor30;
    const custom = this.#config.galleryCustom || {};
    const fallbackSlides = Array.isArray(mediaByFlavor?.[this.#flavor])
      ? mediaByFlavor[this.#flavor].filter((url) => this.#isUsableImage(url))
      : [];

    /** @type {string[]} */
    const images = [];

    // Slide 1: plan kit hero (90-day uses Three Month Pack art), else custom/fallback
    const planHero = this.#getPlanHeroImage();
    const custom1 = custom[`${this.#flavor}-1`];
    if (this.#isUsableImage(planHero)) {
      images.push(planHero);
    } else if (this.#isUsableImage(custom1)) {
      images.push(custom1);
    } else if (this.#isUsableImage(fallbackSlides[0])) {
      images.push(fallbackSlides[0]);
    }

    // Skip gallery slide 2 (packshot) — client: hide second image in gallery row

    // Slide 3 (lifestyle / glass)
    const custom3 = custom[`${this.#flavor}-3`];
    if (this.#isUsableImage(custom3)) {
      images.push(custom3);
    } else if (this.#isUsableImage(fallbackSlides[2])) {
      images.push(fallbackSlides[2]);
    }

    const shared = this.#config.images?.galleryShared || {};
    if (this.#isUsableImage(shared['4'])) images.push(shared['4']);
    if (this.#isUsableImage(shared['5'])) images.push(shared['5']);

    return [...new Set(images.filter((url) => this.#isUsableImage(url)))].slice(0, 4);
  }

  /** @returns {string | null} */
  #getFlavorThumb() {
    // Kit list thumb stays the same on 30/90 — do not swap to plan hero
    const thumb = this.#config.images?.thumbs?.[this.#flavor];
    if (this.#isUsableImage(thumb)) return thumb;

    const variantImage30 = this.#config.variantImages30?.[this.#flavor];
    if (this.#isUsableImage(variantImage30)) return variantImage30;

    const variantImage90 = this.#config.variantImages90?.[this.#flavor];
    if (this.#isUsableImage(variantImage90)) return variantImage90;

    return (
      this.#config.plans?.monthly?.variants?.[this.#flavor]?.featuredImage ||
      this.#config.plans?.p90?.variants?.[this.#flavor]?.featuredImage ||
      null
    );
  }

  #getPrices() {
    const variant = this.#getVariant();
    if (!variant) return { full: 0, now: 0 };

    if (this.#plan === 'p90') {
      const full = this.#config.singleUnitPrice * 3;
      const now = variant.sellingPlanPrice ?? variant.price;
      return { full, now };
    }

    return {
      full: variant.compareAt ?? variant.price,
      now: variant.sellingPlanPrice ?? variant.price,
    };
  }

  /** @param {string} planKey */
  #firstAvailableFlavor(planKey) {
    const variants = this.#config.plans?.[planKey]?.variants || {};
    for (const key of FLAVOR_ORDER) {
      if (variants[key] && this.#config.flavors?.[key]) return key;
    }
    return Object.keys(variants)[0] || 'pl';
  }

  #ensureFlavorForPlan() {
    if (!this.#getVariant()) {
      this.#flavor = this.#firstAvailableFlavor(this.#plan);
    }
  }

  #buildFlavorButtons() {
    const wrap = this.querySelector('[data-atf-flavors]');
    if (!wrap) return;

    this.#ensureFlavorForPlan();
    wrap.innerHTML = '';
    const variants = this.#config.plans?.[this.#plan]?.variants || {};
    for (const key of FLAVOR_ORDER) {
      const f = this.#config.flavors[key];
      if (!f || !variants[key]) continue;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'clc-atf__fl';
      btn.dataset.flav = key;
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', key === this.#flavor ? 'true' : 'false');
      btn.innerHTML = `<i style="background:${f.color}"></i>${f.name}`;
      wrap.appendChild(btn);
    }
  }

  #bindEvents() {
    this.querySelector('[data-atf-plans]')?.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-plan]');
      if (!btn) return;
      this.#plan = btn.dataset.plan === 'p90' ? 'p90' : 'monthly';
      this.#galleryIndex = 0;
      this.#buildFlavorButtons();
      this.#render();
    });

    this.querySelector('[data-atf-flavors]')?.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-flav]');
      if (!btn) return;
      this.#flavor = btn.dataset.flav || 'pl';
      this.#galleryIndex = 0;
      this.#render();
    });

    this.querySelector('[data-atf-thumbs]')?.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-gallery-i]');
      if (!btn) return;
      this.#galleryIndex = Number(btn.dataset.galleryI) || 0;
      this.#renderGallery();
    });

    this.querySelector('[data-atf-rewards-toggle]')?.addEventListener('click', () => {
      const rw = this.querySelector('[data-atf-rewards]');
      const body = rw?.querySelector('.clc-atf__rw-body');
      const head = this.querySelector('[data-atf-rewards-toggle]');
      const plus = head?.querySelector('.clc-atf__plus');
      if (!rw || !body || !head) return;
      const open = rw.classList.toggle('open');
      body.hidden = !open;
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (plus) plus.textContent = open ? '×' : '+';
    });

    this.querySelectorAll('.clc-atf__tab-h').forEach((btn) => {
      btn.addEventListener('click', () => this.#toggleTab(btn));
    });

    this.querySelector('[data-atf-np-open]')?.addEventListener('click', () => this.#openNP());
    this.querySelector('[data-atf-np-close]')?.addEventListener('click', () => this.#closeNP());
    this.querySelector('[data-atf-np-ov]')?.addEventListener('click', (e) => {
      if (e.target === e.currentTarget) this.#closeNP();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.#closeNP();
    });

    const form = this.querySelector('#clc-atf-product-form');
    form?.addEventListener(
      'submit',
      (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.#handleSubmit(e);
      },
      true
    );

    const startCheckout = (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.#handleSubmit(e);
    };

    this.querySelector('[data-atf-cta]')?.addEventListener('click', startCheckout);
    this.querySelector('[data-atf-sticky-cta]')?.addEventListener('click', startCheckout);
  }

  #preserveScrollPosition(scrollY) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (Math.abs(window.scrollY - scrollY) > 1) {
          window.scrollTo(0, scrollY);
        }
      });
    });
  }

  #toggleTab(btn) {
    const scrollY = window.scrollY;
    const tab = btn.closest('.clc-atf__tab');
    if (!tab) return;

    const wasOpen = tab.classList.contains('open');
    const tabBody = tab.querySelector('.clc-atf__tab-b');

    if (wasOpen) {
      tab.classList.remove('open');
      if (tabBody) tabBody.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      this.#preserveScrollPosition(scrollY);
      return;
    }

    this.querySelectorAll('.clc-atf__tab').forEach((t) => {
      t.classList.remove('open');
      const b = t.querySelector('.clc-atf__tab-b');
      const h = t.querySelector('.clc-atf__tab-h');
      if (b) b.hidden = true;
      if (h) h.setAttribute('aria-expanded', 'false');
    });

    tab.classList.add('open');
    if (tabBody) tabBody.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    this.#preserveScrollPosition(scrollY);
  }

  #openNP() {
    this.#paintNP();
    const ov = this.querySelector('[data-atf-np-ov]');
    ov?.classList.add('open');
    ov?.removeAttribute('hidden');
    this.#lockPageScroll(true);
  }

  #closeNP() {
    const ov = this.querySelector('[data-atf-np-ov]');
    if (!ov?.classList.contains('open')) return;

    ov.classList.remove('open');
    ov.setAttribute('hidden', '');
    this.#lockPageScroll(false);
  }

  /** @param {boolean} lock */
  #lockPageScroll(lock) {
    const body = document.body;
    if (!(body instanceof HTMLElement)) return;

    if (lock) {
      if (body.dataset.clcAtfScrollLock === '1') return;
      body.dataset.clcAtfScrollLock = '1';
      body.dataset.clcAtfScrollY = String(window.scrollY);
      body.style.overflow = 'hidden';
      body.style.position = 'fixed';
      body.style.top = `-${body.dataset.clcAtfScrollY}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      return;
    }

    if (body.dataset.clcAtfScrollLock !== '1') return;
    const y = Number(body.dataset.clcAtfScrollY || '0');
    delete body.dataset.clcAtfScrollLock;
    delete body.dataset.clcAtfScrollY;
    body.style.overflow = '';
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    window.scrollTo(0, y);
  }

  #paintNP() {
    const flav = this.#config.flavors[this.#flavor];
    const nutri = NUTRI[this.#flavor];
    this.querySelector('[data-atf-np-flav]')?.replaceChildren(document.createTextNode(flav?.name || ''));
    const ing = this.querySelector('[data-atf-np-ing]');
    const note = this.querySelector('[data-atf-np-note]');
    if (ing && nutri) ing.textContent = nutri.ing;
    if (note && nutri) note.innerHTML = nutri.note;
  }

  #render() {
    const plan = PLANS[this.#plan];
    const variant = this.#getVariant();
    const flavName = this.#config.flavors[this.#flavor]?.name || '';

    this.querySelectorAll('[data-plan]').forEach((el) => {
      const on = el.dataset.plan === this.#plan;
      el.classList.toggle('on', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    this.querySelectorAll('[data-flav]').forEach((el) => {
      const on = el.dataset.flav === this.#flavor;
      el.classList.toggle('on', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    const monthlyPrices = this.#planPrices('monthly');
    const p90Prices = this.#planPrices('p90');

    const monthlyPriceEl = this.querySelector('[data-atf-plan-monthly-price]');
    const monthlyDailyEl = this.querySelector('[data-atf-plan-monthly-daily]');
    const p90PriceEl = this.querySelector('[data-atf-plan-p90-price]');
    const p90DailyEl = this.querySelector('[data-atf-plan-p90-daily]');

    if (monthlyPriceEl) monthlyPriceEl.innerHTML = `${this.#money(monthlyPrices.now)} <span>/month</span>`;
    if (monthlyDailyEl) monthlyDailyEl.textContent = `${this.#dailyPrice(monthlyPrices.now, 30)} a day`;
    if (p90PriceEl) p90PriceEl.innerHTML = `${this.#money(p90Prices.now)} <span>/3 months</span>`;
    if (p90DailyEl) p90DailyEl.textContent = `${this.#dailyPrice(p90Prices.now, 90)} a day`;

    this.querySelector('[data-atf-kit-name]')?.replaceChildren(document.createTextNode(plan.name));

    const prices = this.#getPrices();
    const kitFullEl = this.querySelector('[data-atf-kit-full]');
    const kitNowEl = this.querySelector('[data-atf-kit-now]');
    if (kitFullEl instanceof HTMLElement) {
      kitFullEl.textContent = this.#money(prices.full);
      kitFullEl.hidden = !(prices.full > prices.now);
    }
    if (kitNowEl) kitNowEl.textContent = this.#money(prices.now);

    const subEl = this.querySelector('[data-atf-kit-sub]');
    if (subEl) subEl.innerHTML = plan.sub;
    this.querySelector('[data-atf-ship]')?.replaceChildren(document.createTextNode(plan.ship));

    this.#renderKitItems(plan, flavName);
    const keepEl = this.querySelector('[data-atf-keep]');
    if (keepEl) keepEl.innerHTML = plan.keep;

    const cta = this.querySelector('[data-atf-cta]');
    const stickyCta = this.querySelector('[data-atf-sticky-cta]');
    if (cta) cta.textContent = plan.cta;
    if (stickyCta) stickyCta.textContent = plan.cta;

    const underEl = this.querySelector('[data-atf-under]');
    if (underEl) underEl.innerHTML = plan.under;

    const guarEl = this.querySelector('[data-atf-guar]');
    if (guarEl instanceof HTMLElement) {
      guarEl.hidden = this.#plan !== 'p90';
    }

    const recapEl = this.querySelector('[data-atf-sticky-recap]');
    if (recapEl) recapEl.textContent = plan.recap;

    const giftIntro = this.querySelector('[data-atf-gift-intro]');
    if (giftIntro) giftIntro.textContent = plan.giftIntro;

    this.#renderIngredients();
    this.#paintNP();
    this.#renderGallery();
    this.#syncForm(variant);
  }

  #planPrices(planKey) {
    const savedPlan = this.#plan;
    const savedFlavor = this.#flavor;
    this.#plan = planKey;
    if (!this.#getVariant()) {
      this.#flavor = this.#firstAvailableFlavor(planKey);
    }
    const p = this.#getPrices();
    this.#plan = savedPlan;
    this.#flavor = savedFlavor;
    return p;
  }

  #renderKitItems(plan, flavName) {
    const wrap = this.querySelector('[data-atf-items]');
    if (!wrap) return;

    const imgs = this.#config.images;
    const thumb = this.#getFlavorThumb();

    /** @type {Array<{img: string | null | undefined, title: string, desc: string, tag: string}>} */
    const rows = [
      {
        img: thumb,
        title: plan.el,
        desc: plan.elp.replace('{F}', flavName),
        tag: plan.tag,
      },
    ];

    // HydroProtein row — 90-Day only
    if (this.#plan === 'p90' && plan.extra) {
      rows.push({
        img: imgs?.gifts?.hydro,
        title: 'The HydroProtein Elixir',
        desc: '15g of protein & electrolytes daily',
        tag: 'Included',
      });
    }

    rows.push(
      { img: imgs?.gifts?.caddy, title: 'The Super Elixir™ Caddy', desc: 'Elegant refillable caddy', tag: 'Included' },
      { img: imgs?.gifts?.spoon, title: 'The Measuring Spoon', desc: 'The exact daily dose', tag: 'Included' },
      { img: imgs?.gifts?.bottle, title: 'The On-The-Go Bottle', desc: 'Glass & steel, no plastic', tag: 'Included' }
    );

    wrap.innerHTML = rows
      .map(
        (r) => `
      <div class="clc-atf__item">
        <div class="clc-atf__item-ph">${r.img ? `<img class="clc-atf__fit" src="${r.img}" alt="" loading="lazy">` : ''}</div>
        <div><h3>${r.title}</h3><p>${r.desc}</p></div>
        <span class="clc-atf__tag">${r.tag}</span>
      </div>`
      )
      .join('');

    const giftsWrap = this.querySelector('[data-atf-future-gifts]');
    if (giftsWrap) {
      const gifts =
        Array.isArray(this.#config.futureGifts) && this.#config.futureGifts.length > 0
          ? this.#config.futureGifts
          : FUTURE_GIFTS;
      const deliveryLabels = Array.isArray(plan.giftDeliveryLabels) ? plan.giftDeliveryLabels : null;

      giftsWrap.innerHTML = gifts
        .map(
          (g, i) => `
        <div class="clc-atf__gift">
          <div class="clc-atf__gift-ph">${g.image ? `<img class="clc-atf__fit" src="${g.image}" alt="" loading="lazy">` : ''}</div>
          <div><span class="m">${deliveryLabels?.[i] || g.month}</span><h4>${g.title}</h4><p>${g.desc || g.description || ''}</p></div>
          <div class="clc-atf__gift-pr"><s>${g.was}</s><b>Free</b></div>
        </div>`
        )
        .join('');
    }
  }

  #renderIngredients() {
    const wrap = this.querySelector('[data-atf-ingredients]');
    if (!wrap) return;
    const rows = INGREDIENTS[this.#flavor] || INGREDIENTS.pl;
    wrap.innerHTML = rows
      .map((r) => `<div class="clc-atf__ing"><b>${r.label}</b><p>${r.text}</p></div>`)
      .join('');
  }

  #renderGallery() {
    const images = this.#buildGalleryImages();
    const heroImg = this.querySelector('[data-atf-hero]');
    const fallback = this.#getVariant()?.featuredImage || images[0] || '';
    const src = images[this.#galleryIndex] || images[0] || fallback;

    if (heroImg instanceof HTMLImageElement) {
      heroImg.src = src;
      heroImg.alt = this.#config.flavors[this.#flavor]?.name || 'The Super Elixir';
      heroImg.onerror = () => {
        heroImg.onerror = null;
        if (fallback) heroImg.src = fallback;
      };
    }

    const thumbs = this.querySelector('[data-atf-thumbs]');
    if (!thumbs) return;

    thumbs.innerHTML = images
      .slice(0, 5)
      .map(
        (url, i) => `
      <button type="button" class="clc-atf__thumb ${i === this.#galleryIndex ? 'on' : ''}" data-gallery-i="${i}" aria-label="Gallery image ${i + 1}">
        <img class="clc-atf__fit" src="${url}" alt="" loading="lazy" onerror="this.closest('button')?.remove()">
      </button>`
      )
      .join('');
  }

  #syncForm(variant) {
    const variantInput = this.querySelector('[data-atf-variant-input]');
    const planInput = this.querySelector('[data-atf-selling-plan]');

    if (variantInput instanceof HTMLInputElement && variant) {
      variantInput.value = String(variant.id);
    }

    if (planInput instanceof HTMLInputElement) {
      if (variant?.sellingPlanId) {
        planInput.name = 'selling_plan';
        planInput.value = String(variant.sellingPlanId);
      } else {
        planInput.removeAttribute('name');
        planInput.value = '';
      }
    }
  }

  /** @returns {number[]} */
  #getGiftVariantIds() {
    const ids = [
      Number(this.dataset.giftCaddy),
      Number(this.dataset.giftSpoon),
      Number(this.dataset.giftBottle),
    ];

    if (this.#plan === 'p90') {
      ids.push(Number(this.dataset.giftHydro));
    }

    return ids.filter((id) => Number.isFinite(id) && id > 0);
  }

  #cartRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  /**
   * @param {string} root
   * @param {Record<string, string>} headers
   * @param {Array<{id: number, quantity: number, selling_plan?: number, properties?: Record<string, string>}>} items
   */
  async #addItems(root, headers, items) {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ items }),
    });
    const body = await res.json().catch(() => ({}));
    return { ok: res.ok, status: res.status, body };
  }

  #resetCheckoutUi() {
    this.dataset.checkoutBusy = 'false';

    const label = PLANS[this.#plan]?.cta || 'Start My Ritual';
    const cta = this.querySelector('[data-atf-cta]');
    const stickyCta = this.querySelector('[data-atf-sticky-cta]');

    for (const btn of [cta, stickyCta]) {
      if (!(btn instanceof HTMLButtonElement)) continue;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.textContent = label;
    }
  }

  async #handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();

    if (this.dataset.checkoutBusy === 'true') return;
    this.dataset.checkoutBusy = 'true';

    const variant = this.#getVariant();
    if (!variant?.id) {
      this.#resetCheckoutUi();
      console.error('CLC ATF: no variant for', this.#plan, this.#flavor, this.#config?.plans);
      window.alert('Could not find this flavour/plan. Please refresh and try again.');
      return;
    }

    const cta = this.querySelector('[data-atf-cta]');
    const stickyCta = this.querySelector('[data-atf-sticky-cta]');
    const buttons = [cta, stickyCta].filter((b) => b instanceof HTMLButtonElement);

    for (const btn of buttons) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Starting checkout…';
    }

    const root = this.#cartRoot();
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    try {
      // Clear quietly — do not open the cart drawer
      await fetch(`${root}cart/clear.js`, { method: 'POST', headers });

      /** @type {{id: number, quantity: number, selling_plan?: number}} */
      const mainItem = {
        id: Number(variant.id),
        quantity: 1,
      };
      if (variant.sellingPlanId) {
        mainItem.selling_plan = Number(variant.sellingPlanId);
      }

      // 1) Add ritual product alone (subscription). Gifts in the same request often 422.
      let mainResult = await this.#addItems(root, headers, [mainItem]);

      // Retry without selling_plan only if the plan id was rejected
      if (!mainResult.ok && mainItem.selling_plan) {
        console.warn('CLC ATF: selling_plan add failed, retrying once', mainResult.body);
        const otpItem = { id: mainItem.id, quantity: 1 };
        mainResult = await this.#addItems(root, headers, [otpItem]);
        if (mainResult.ok) {
          console.warn('CLC ATF: added without selling_plan — check Recharge allocation for', variant);
        }
      }

      if (!mainResult.ok) {
        throw new Error(
          mainResult.body?.description ||
            mainResult.body?.message ||
            `Add to cart failed (${mainResult.status})`
        );
      }

      // 2) Add gifts one-by-one so one bad gift cannot wipe the ritual line
      for (const giftId of this.#getGiftVariantIds()) {
        const giftResult = await this.#addItems(root, headers, [
          {
            id: giftId,
            quantity: 1,
            properties: { _clc_atf_gift: 'true' },
          },
        ]);
        if (!giftResult.ok) {
          console.warn('CLC ATF: gift skipped', giftId, giftResult.body);
        }
      }

      window.location.assign(`${root}checkout`);
    } catch (err) {
      console.error(err);
      this.#resetCheckoutUi();
      window.alert(err instanceof Error ? err.message : 'Could not start checkout. Please try again.');
    }
  }

  #initSticky() {
    const bar = this.querySelector('[data-atf-sticky]');
    const atc = this.querySelector('[data-atf-cta]');
    if (!bar || !atc) return;

    bar.removeAttribute('hidden');

    const chk = () => {
      bar.classList.toggle('show', atc.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', chk, { passive: true });
    chk();
  }
}

if (!customElements.get('clc-tse-atf-01')) {
  customElements.define('clc-tse-atf-01', ClcTseAtf01);
}
